var _rect, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 1024,
    viewBox: "0 0 588 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    width: 523,
    height: 1024,
    fill: "#115264"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.36 579.122C246.36 539.842 278.202 508 317.482 508H507.732C551.921 508 587.744 543.823 587.744 588.012C587.744 632.201 551.921 668.024 507.732 668.024H246.36V579.122Z",
    fill: "#9A8C6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.505 774.706C477.505 813.985 445.663 845.828 406.383 845.828H326.372C282.182 845.828 246.36 810.005 246.36 765.816C246.36 721.627 282.182 685.804 326.371 685.804H477.505V774.706Z",
    fill: "#9E0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 588.012C65 543.823 100.823 508 145.012 508C189.201 508 225.024 543.823 225.024 588.012V845.828H171.682C112.763 845.828 65 798.064 65 739.145V588.012Z",
    fill: "#F4A807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.012 1024.02C285.823 1024.02 250 988.2 250 944.01C250 899.821 285.822 863.999 330.012 863.999L587.828 863.998L587.828 917.34C587.828 976.259 540.064 1024.02 481.145 1024.02L330.012 1024.02Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.579,
    cy: 801.451,
    rx: 44.5793,
    ry: 44.4509,
    fill: "#F4A807"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.5,
    cy: 943.999,
    rx: 80.5,
    ry: 80,
    fill: "#9E0000"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.579,
    cy: 453.451,
    rx: 44.5793,
    ry: 44.4509,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.114 498.228C49.7476 498.228 -2.17454e-06 448.48 -4.85697e-06 387.113C-7.53941e-06 325.746 50.3325 275.999 111.699 275.999C173.716 275.999 224.581 326.273 224.581 388.289L224.581 498.228L111.114 498.228Z",
    fill: "#9E0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5083 364.628L112.153 430.467L152.229 364.628",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.874 433.326H32.9543L113.107 296.399L190.874 433.326Z",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4306 341.723L191.35 341.723L111.198 478.65L33.4306 341.723Z",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9077 342.202L111.675 387.527V478.175",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M190.394 341.721L111.195 387.522",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5083 364.628H151.275",
    stroke: "white",
    strokeWidth: 2.93954
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M360.704 780.938L383.048 815.016L404.884 779.499",
    stroke: "white",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.221 815.499L362.003 707.486L424.786 815.499H299.221Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.128 815.882L320.855 780.736H360.811L381.495 743.115H340.932",
    stroke: "white",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 452.999,
    r: 32.4531,
    stroke: "#9E0000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 452.999,
    r: 36.5,
    stroke: "#9E0000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.289,
    cy: 453.288,
    r: 24.1484,
    stroke: "#9E0000",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.289,
    cy: 453.288,
    r: 12.5078,
    stroke: "#9E0000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.289,
    cy: 453.288,
    r: 8.46094,
    stroke: "#9E0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/getStarted.33d24a5a6f80e1af91a4493bca214c3d.svg";
export { ForwardRef as ReactComponent };